module.exports = "/fast-coin/img/coin/anim/in/coin_in_011.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_011.png
// module id = 2281
// module chunks = 5